import { ProductReceiptsApiResponse } from '@repo/accounts-types'
import { ApiResponse, GenericOperationState } from '@repo/core'
import { RootState } from '../../../store/types'

export const bankingProductLoanReceiptsDataSelectorConfig = {
  bankingProductLoanReceiptsDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<ProductReceiptsApiResponse> | null> {
      return state.accounts.master.list.bankingProductLoanReceipts
    },
  },
}
